const emotional_lotties = {
  score100: require("../assets/lotties/score100.json"),
  taskCompletion: require("../assets/lotties/taskCompletion.json"),
  target: require("../assets/lotties/target.json"),
  successBelow60: require("../assets/lotties/success_below_60.json"),
  success6080: require("../assets/lotties/success_60_80.json"),
  sucess80100: require("../assets/lotties/success_80_100.json"),
  success100: require("../assets/lotties/success_100.json"),
};

export default emotional_lotties;
